import { animate, style, transition, trigger } from "@angular/animations";
import { HttpHeaders } from "@angular/common/http";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EDITOR_TOOLBAR, EMOJI_REGEX } from "app/models/ckeditor-config";
import Editor from "egmat-ckeditor5";
import { HttpClientService } from "../../Services/http-client.service";
import { SessionService } from "../../Services/session.service";
import { AppSettings } from "../../app-settings";
declare var MathJax: any;
@Component({
  selector: "app-forums-user",
  templateUrl: "./forums-user.component.html",
  styleUrls: ["./forums-user.component.scss"],
  animations: [
    trigger("scrollUpInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.5s", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.5s", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class ForumsUserComponent implements OnInit {
  @HostListener("window:scroll", ["$event"])
  onWindowScroll(event) {
    if (event.currentTarget.pageYOffset > 3818) {
      this.backToTopImg = true;
    } else {
      this.backToTopImg = false;
    }
  }
  constructor(
    private sessionService: SessionService,
    private route: ActivatedRoute,
    private httpClientService: HttpClientService
  ) {}

  forumMode: string = "ACTIVITY";
  isReviewMode: number = 0;

  krishnaImage = AppSettings.cdnUrl + "assets/images/KrishnaProfile1.png";
  notLikedImage = AppSettings.cdnUrl + "assets/images/notliked.png";
  notDislikedImage = AppSettings.cdnUrl + "assets/images/notdisliked.png";
  likedImage = AppSettings.cdnUrl + "assets/images/liked.png";
  dislikedImage = AppSettings.cdnUrl + "assets/images/disliked.png";
  downLessImage = AppSettings.cdnUrl + "assets/images/down_arrow_more.png";
  upMoreImage = AppSettings.cdnUrl + "assets/images/up_arrow_more_less.png";
  scrollTopImage = AppSettings.cdnUrl + "assets/images/up-arrow-forums.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  randomColors = [
    "#2a098d",
    "#3d9d01",
    "#c47439",
    "#23c6e4",
    "#1156de",
    "#03254e",
    "#5601a7",
    "#5e1317",
    "#27AE60",
    "#A569BD",
    "#df715f",
    "#e084cd",
    "#093c3e",
    "#616252",
    "#0f5d7e",
    "#23776e",
    "#7b789f",
    "#aa85fc",
    "#ac2001",
    "#154360",
    "#B7950B",
  ];

  originalScrollPostition: number;
  newQueryPost: boolean = false;
  ckeditorNewQueryContent: string = "";
  postQueryHeading: string = "";
  singleForum: any = {};
  likeDislikeArray: any = [];
  totalLikeDislike: any = {};
  AllForums: any = [];
  activityId: number;
  AllForumsTemplateData = [];
  threadExpandedArray: any = [];
  corelationID: string;
  ReviewMode: boolean = false;
  discussionIDVsCorelationID: any = [];
  corelationIDList: any = {};
  scrollOnce: boolean = true;
  emptyMainPost: boolean = false;
  emptyPostSubject: boolean = false;
  characterExceedSubjectError: boolean = false;
  characterExceedError: boolean = false;
  showForumsOnLoad: boolean = false;
  scrolltoSlideForums = false;
  insideArray: any = [];
  levelIndentValue: number = 0;
  activityForumsDisplayHide: boolean = false;
  ckEditorWordsLimit: number = 3000;
  ckEditorHeadingLimit: number = 300;
  addToNotesSingle: boolean = true;
  postnewQuerySingle: boolean = true;
  forumLoadedFlag: boolean = false;
  loadForumsData: boolean = true;
  backToTopImg: boolean = false;
  numberOfQuestionsRemaining: number = 0;
  has80PercentQuotaExceeded: boolean = false;
  hasQuotaExceeded: boolean = true;
  endDateString: string;
  numberOfForumQuestionPosted: number = 0;
  totalNumberOfQuota: number = 7;
  isFreeTrialUser: boolean = false;
  faqFeatureEnabled: boolean = true;
  accessedForumsFlag: boolean = false;
  forumTypeSubscription;
  forumReadOnlyMode: boolean = false;
  displayImportantPostsPrompt: boolean = false;
  editor = Editor as any;
  ckEditorConfigFocused: any = { toolbar: EDITOR_TOOLBAR, startupFocus: true };
  ckEditorConfigNormal: any = { toolbar: EDITOR_TOOLBAR };
  @ViewChild("_displayForumsThreadAfter", { static: false })
  displayForumsThreadAfter: ElementRef;
  @ViewChild("_displayForumsThreadStart", { static: true })
  displayForumsThreadStart: ElementRef;
  tabActive: string = "important";
  loadFirstTime: boolean = true;
  isNewUser = false;
  ngOnInit() {
    this.sessionService.sharedAccessedForumsState$.subscribe((item) => {
      if (item != undefined && item != null && item != "") {
        this.accessedForumsFlag = item;
      }
    });

    this.getForumsMode();
    this.getThreadExpansion();

    this.sessionService.updateForumsData$.subscribe((item) => {
      if (item != 0) {
        //console.log("slidechange" + item);
        if (this.forumMode == "SLIDE") {
          this.AllForumsTemplateData = [];
          this.showForumsOnLoad = false;
        }
      }
    });

    this.sessionService.updateDashboard$.subscribe((item) => {
      if (item != 0) {
        //console.log("forums loaded" + item);
        this.showForumsOnLoad = true;
        this.scrolltoSlideForums = true;
        this.getForumsData(true, "", false);
      }
    });

    this.sessionService.updateActivityForumsDisplayState$.subscribe((item) => {
      if (item != 0) {
        this.activityForumsDisplayHide = false;
        this.showForumsOnLoad = true;
        this.scrolltoSlideForums = true;
        this.getForumsDataOnReviewButtonClick();
      }
    });
    this.sessionService.updateAddedToNotesFlag$.subscribe((item) => {
      if (item != 0) {
        this.changeAddedToNoteFlag(item);
      }
    });
    this.sessionService.sharedForumType.subscribe((data) => {
      if (data) {
        if (data == "ACTIVITY_READ_ONLY") {
          this.forumReadOnlyMode = true;
        }
      }
    });
  }
  ngOnDestroy() {
    this.sessionService.updateActivityForumsDisplayState(0);
    this.sessionService.shareForumType("");
  }
  getForumsMode() {
    this.route.params.subscribe((params) => {
      if (params["activity"]) {
        this.activityId = params["activity"];
        /*let headers = new HttpHeaders();
                  this.httpClientService.get(AppSettings.restApiUrl +
                  '/api/activity/'+this.activityId+'/forum/0/', headers)
                  .subscribe(
                  (data) => {
                    this.forumMode = data.forumType;
                    if(this.forumMode == "ACTIVITY")
                    {
                       this.getForumsData();
                       this.showForumsOnLoad = true;
                       //this.activityForumsDisplayHide = true;
                       //this.scrolltoSlideForums = true;
                    }
                    else
                    {
                       this.showForumsOnLoad = false;
                       this.activityForumsDisplayHide = false;
                    }
                  });*/
        this.displayForumsThreadStart.nativeElement.style.display = "none";
        this.showForumsOnLoad = false;
        this.activityForumsDisplayHide = false;
        this.ReviewMode = false;
        this.isReviewMode = 0;
        this.forumLoadedFlag = false;
        this.loadForumsData = true;
        //this.showForumsOnLoad = true;
      } else if (params["corelationid"]) {
        this.corelationID = params["corelationid"];
        this.getReviewModeForums(this.corelationID);
        this.ReviewMode = true;
        this.isReviewMode = 1;
        this.showForumsOnLoad = true;
        this.activityForumsDisplayHide = false;
        // this.forumLoadedFlag = true;
      }
    });
  }
  getReviewModeForums(corelationId) {
    this.forumLoadedFlag = false;
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl + "/api/link/forum/" + corelationId + "/",
        headers
      )
      .subscribe((data) => {
        this.activityId = data.forumObjectId;
        this.tabActive = data.defaultView;
        let primrary = this.tabActive == "important" ? true : false;
        this.getForumsData(primrary, "", false);
      });
  }

  getForumsDataOnReviewButtonClick() {
    if (this.scrolltoSlideForums) {
      this.scrollToFormus();
      this.scrolltoSlideForums = false;
    }

    if (this.loadForumsData) {
      this.getForumsData(true, "", false);
      this.loadForumsData = false;
    }
  }

  getForumsData(isPrimrary, scrollToId, followedUpPost) {
    let apiURL;
    if (this.faqFeatureEnabled) {
      apiURL =
        AppSettings.restApiUrl +
        "/api/ACTIVITY/" +
        this.activityId +
        "/forum/" +
        this.isReviewMode +
        "/view/" +
        isPrimrary +
        "/" +
        this.accessedForumsFlag;
    } else {
      apiURL =
        AppSettings.restApiUrl +
        "/api/ACTIVITY/" +
        this.activityId +
        "/forum/" +
        this.isReviewMode +
        "/ASC/" +
        this.accessedForumsFlag;
    }
    this.forumLoadedFlag = false;
    let headers = new HttpHeaders();
    this.httpClientService.get(apiURL, headers).subscribe((data) => {
      if (data.showImportantPosts != undefined)
        this.displayImportantPostsPrompt = data.showImportantPosts;

      this.forumLoadedFlag = true;
      this.accessedForumsFlag = false;
      this.sessionService.shareAccessedForumsState(false);
      this.tabActive = data.defaultView;
      this.AllForums = [];
      var forumsData = data;
      this.isNewUser = data.newUsers;
      if (forumsData.forumPostsVO != null) {
        var allThreads = forumsData.forumPostsVO;
        var totalPosts = allThreads.length;
        for (var i = 0; i < totalPosts; i++) {
          var forum = this.addSinglePost(i, allThreads, 0);

          if (allThreads[i].forumPostsVO != null) {
            this.insideArray = [];
            //for(var j=0;j<allThreads[i].forumPostsVO.length;j++)
            //{
            //forum.forumPostsVO.push(this.addSinglePost(j,allThreads[i].forumPostsVO));
            this.singleArray(allThreads[i].forumPostsVO, 0);
            forum.forumPostsVO = this.insideArray;
            //}
          } else {
            allThreads[i].forumPostsVO = [];
          }
          this.AllForums.push(forum);
        }
        this.forumLoadedFlag = true;
        this.AllForumsTemplateData = this.AllForums;
        if (this.ReviewMode) {
          this.setThreadExpansion(
            this.getIndexofThread(this.getdiscussionID(this.corelationID)),
            true
          );
        }
      } else {
        this.forumLoadedFlag = true;
        this.AllForumsTemplateData = [];
      }
      if (this.tabActive == "important") {
        if (this.AllForums.length == 0 && this.loadFirstTime) {
          this.loadFirstTime = false;
          this.toggleTab("others");
        }
      }
      let forumPostQuota = data.forumPostQuota;
      let postsDoneForThisCycle = data.postsDoneForThisCycle;
      let eightyPercentQuota = Math.floor((forumPostQuota / 100) * 80);
      this.numberOfQuestionsRemaining = forumPostQuota - postsDoneForThisCycle;
      if (data.nextCycleStartDate != null) {
        this.endDateString = this.formatQuotaDate(data.nextCycleStartDate);
      } else {
        this.endDateString = data.nextCycleStartDate;
      }
      this.numberOfForumQuestionPosted = data.postsDoneForThisCycle;
      this.totalNumberOfQuota = data.forumPostQuota;
      if (
        postsDoneForThisCycle >= eightyPercentQuota &&
        postsDoneForThisCycle < forumPostQuota
      ) {
        this.has80PercentQuotaExceeded = true;
      } else {
        this.has80PercentQuotaExceeded = false;
      }
      if (postsDoneForThisCycle >= forumPostQuota) {
        this.hasQuotaExceeded = true;
      } else {
        this.hasQuotaExceeded = false;
      }
      this.isFreeTrialUser = data.isFreeTrial;
      /*if(this.forumMode == "SLIDE" && this.scrolltoSlideForums)
        {
            this.scrollToFormus();
            this.scrolltoSlideForums = false;
        }*/
      if (scrollToId) {
        if (followedUpPost) {
          scrollToId = this.getCorelationIdUsingDiscussionId(scrollToId);
          this.setThreadExpansion(
            this.getIndexofThread(this.getdiscussionID(scrollToId)),
            true
          );
        }
        this.waitForElementToDisplay(scrollToId, 200);
      }
      this.updateResult();
    });
  }

  filterDiscussions(event: any) {
    //console.log(event.target.checked);
    let showImportantQueries = event.target.checked;
    if (showImportantQueries) {
      this.AllForumsTemplateData = this.AllForums.filter(
        (item) => item["important"]
      );
      //this.defaultView='important';
      //console.log(this.AllForumsTemplateData, this.AllForums);
    } else {
      this.AllForumsTemplateData = this.AllForums;
      //console.log(this.AllForumsTemplateData, this.AllForums);
      //  this.defaultView='others';
    }
  }

  getCorelationIdUsingDiscussionId(discussionId) {
    if (discussionId) {
      let correlationId;
      for (let i = 0; i < this.AllForums.length; i++) {
        if (this.AllForums[i].forumPostsVO.length > 0) {
          let subIndex = this.AllForums[i].forumPostsVO.findIndex((item) => {
            return item.id === discussionId;
          });
          if (subIndex > -1) {
            return this.AllForums[i].forumPostsVO[subIndex]["correlationId"];
          }
        }
      }
    }
  }

  waitForElementToDisplay(selector, time) {
    let then = this;
    if (selector && document.getElementById(selector)) {
      //console.log("gotin", selector);
      this.setThreadExpansion(this.getIndexofThread(selector), true);
      var newQueryPostOffsetY =
        window.scrollY +
        document.getElementById(selector).getBoundingClientRect().top -
        200;
      window.scrollTo(0, newQueryPostOffsetY);
      return;
    } else {
      //console.log("out", selector);
      setTimeout(() => {
        then.waitForElementToDisplay(selector, time);
      }, time);
    }
  }
  singleArray(arr: any, j) {
    if (arr == null) {
      return;
    }
    for (var i = 0; i < arr.length; i++) {
      this.insideArray.push(this.addSinglePost(i, arr, j));
      this.singleArray(arr[i].forumPostsVO, j + 1);
    }
  }

  formatQuotaDate(dateString: string): string {
    let monthNames = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let date = new Date(dateString);
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let dayName = date.getDay();

    return (
      days[dayName] +
      " " +
      monthNames[monthIndex] +
      " " +
      day +
      " " +
      date.toLocaleTimeString()
    );
  }

  scrollToCurrentDiscussion() {
    if (this.ReviewMode) {
      //window.scrollTo(0, document.getElementById(this.corelationID).offsetTop);
      var forumsLocation = document.getElementById(this.corelationID).offsetTop;
      if (this.faqFeatureEnabled) {
        forumsLocation =
          document.getElementById(this.corelationID).offsetTop - 220;
      }
      var body = document.body,
        html = document.documentElement;
      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      var scrollheight = height - forumsLocation;
      var timerID = setInterval(function () {
        window.scrollBy(0, 15);
        if (
          window.innerHeight + window.pageYOffset >= height ||
          window.pageYOffset >= forumsLocation ||
          window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 5
        )
          clearInterval(timerID);
      }, 5);
      this.storeScrollPostion();
    }
    this.scrollOnce = false;
  }
  getThreadExpansion() {
    for (var i = 0; i < this.AllForums.length; i++) {
      this.threadExpandedArray.push(false);
    }
  }
  setThreadExpansion(index, state) {
    this.threadExpandedArray[index] = state;
  }
  addSinglePost(i, allThreads, level) {
    this.singleForum = {};
    this.singleForum.id = allThreads[i].id;
    this.singleForum.scrollId = allThreads.id;
    this.singleForum.forumPostSubject = allThreads[i].forumPostSubject;
    this.singleForum.postedBy = allThreads[i].postedBy;
    this.singleForum.forumPostText = allThreads[i].forumPostText;
    if (
      allThreads[i].expertReplyText != null &&
      allThreads[i].expertReplyText != ""
    ) {
      this.singleForum.expertReplyText = allThreads[i].expertReplyText;
    } else {
      this.singleForum.expertReplyText = allThreads[i].expertReplyText;
    }
    this.singleForum.expertReplySubject = allThreads[i].expertReplySubject;
    this.singleForum.expertName = allThreads[i].expertName;
    this.singleForum.expertReplyPostId = allThreads[i].expertReplyPostId;
    this.singleForum.correlationId = allThreads[i].correlationId;
    this.singleForum.expertReplyTotalLikes =
      allThreads[i].expertReplyTotalLikes;
    this.singleForum.expertRepyTotalUnlikes =
      allThreads[i].expertRepyTotalUnlikes;
    this.singleForum.isLikedByUser = allThreads[i].isLikedByUser;
    this.singleForum.followUpAllowed = allThreads[i].followUpAllowed;
    this.singleForum.isUnlikedByUser = allThreads[i].isUnlikedByUser;
    this.singleForum.creationTime = allThreads[i].creationTime;
    this.singleForum.expertResponseTime = allThreads[i].expertResponseTime;
    this.singleForum.forumId = allThreads[i].forumId;
    this.singleForum.parentId = allThreads[i].parentId;
    this.singleForum.discussionId = allThreads[i].discussionId;
    this.singleForum.forumPostType = allThreads[i].forumPostType;
    this.singleForum.forumPostsVO = [];
    this.singleForum.expanded = false;
    this.singleForum.letterColor = this.randomColor(this.singleForum.postedBy);
    this.singleForum.followUpCKEditor = false;
    this.singleForum.followUpCKEditorEmptyPost = false;
    this.singleForum.followUpCKEditorCharacterError = false;
    this.singleForum.followUpCKEditorquery = "";
    this.singleForum.addedToNotes = allThreads[i].addedToNotes;
    this.singleForum.expanded = false;
    this.singleForum.ckEditorExpert = false;
    this.singleForum.postOneTime = true;
    this.singleForum.important = allThreads[i].important;
    if (allThreads[i].expertDisplaypicture == null) {
      this.singleForum.expertDisplaypicture =
        "https://cdn.e-gmat.com/wp-content/themes/twentythirteen/images/egmat3_images/AbhinavPuri.png";
    } else {
      this.singleForum.expertDisplaypicture =
        allThreads[i].expertDisplaypicture;
    }
    this.singleForum.ckEditorExpertPostText = "";
    this.singleForum.level = level;
    if (allThreads[i].expertReplyPostId == null) {
      this.singleForum.expertResponded = false;
    } else {
      this.singleForum.expertResponded = true;
    }
    if (this.singleForum.expertResponded) {
      this.totalLikeDislike = {};
      this.totalLikeDislike.postID = allThreads[i].expertReplyPostId;
      this.totalLikeDislike.isLikedByUser = allThreads[i].isLikedByUser;
      this.totalLikeDislike.isUnlikedByUser = allThreads[i].isUnlikedByUser;
      this.totalLikeDislike.expertReplyTotalLikes =
        allThreads[i].expertReplyTotalLikes;
      this.totalLikeDislike.expertRepyTotalUnlikes =
        allThreads[i].expertRepyTotalUnlikes;
      this.totalLikeDislike.likeImage = this.likeImage(
        allThreads[i].isLikedByUser
      );
      this.totalLikeDislike.disLikeImage = this.disLikeImage(
        allThreads[i].isUnlikedByUser
      );
      this.likeDislikeArray.push(this.totalLikeDislike);
    }
    this.corelationIDList = {};
    this.corelationIDList.discussionID = allThreads[i].discussionId;
    this.corelationIDList.corelationID = allThreads[i].correlationId;
    this.discussionIDVsCorelationID.push(this.corelationIDList);

    return this.singleForum;
  }

  getReactions(postId): any {
    var arrByID = this.likeDislikeArray.filter(function (obj) {
      return obj.postID == postId;
    });
    return arrByID[0];
  }
  getdiscussionID(corelationID) {
    var discussionID = this.discussionIDVsCorelationID.filter(function (obj) {
      return obj.corelationID == corelationID;
    });
    return discussionID[0].discussionID;
  }
  randomColor(userString: string): any {
    var firstLetterCode = userString.trim().toUpperCase().charCodeAt(0);
    var index;
    if (firstLetterCode >= 65 && firstLetterCode <= 74) {
      index = firstLetterCode % 10;
    } else if (firstLetterCode >= 75 && firstLetterCode <= 84) {
      index = (firstLetterCode % 10) + 10;
    } else if (firstLetterCode >= 85 && firstLetterCode <= 90) {
      index = firstLetterCode % 10;
    } else {
      index = 1;
    }
    return this.randomColors[index];
  }
  likeChange(postID) {
    var index = this.getIndex(postID);
    var liked = this.likeDislikeArray[index].isLikedByUser;
    var disliked = this.likeDislikeArray[index].isUnlikedByUser;
    var likedNumbers = this.likeDislikeArray[index].expertReplyTotalLikes;
    var disLikedNumbers = this.likeDislikeArray[index].expertRepyTotalUnlikes;
    if (liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes--;
      this.likeDislikeArray[index].isLikedByUser = false;
      this.deleteReaction(postID);
    } else if (disliked) {
      this.likeDislikeArray[index].expertReplyTotalLikes++;
      this.likeDislikeArray[index].isLikedByUser = true;
      this.likeDislikeArray[index].isUnlikedByUser = false;
      this.likeDislikeArray[index].expertRepyTotalUnlikes--;
      this.likeDislikeArray[index].disLikeImage = this.disLikeImage(
        this.likeDislikeArray[index].isUnlikedByUser
      );
      this.postReaction(postID, "LIKE");
    } else if (!liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes++;
      this.likeDislikeArray[index].isLikedByUser = true;
      this.postReaction(postID, "LIKE");
    }
    this.likeDislikeArray[index].likeImage = this.likeImage(
      this.likeDislikeArray[index].isLikedByUser
    );
  }
  dislikeChange(postID) {
    var index = this.getIndex(postID);
    var liked = this.likeDislikeArray[index].isLikedByUser;
    var disliked = this.likeDislikeArray[index].isUnlikedByUser;
    var likedNumbers = this.likeDislikeArray[index].expertReplyTotalLikes;
    var disLikedNumbers = this.likeDislikeArray[index].expertRepyTotalUnlikes;
    if (liked) {
      this.likeDislikeArray[index].expertReplyTotalLikes--;
      this.likeDislikeArray[index].isLikedByUser = false;
      this.likeDislikeArray[index].isUnlikedByUser = true;
      this.likeDislikeArray[index].expertRepyTotalUnlikes++;
      this.likeDislikeArray[index].likeImage = this.likeImage(
        this.likeDislikeArray[index].isLikedByUser
      );
      this.postReaction(postID, "UNLIKE");
    } else if (!disliked) {
      this.likeDislikeArray[index].isUnlikedByUser = true;
      this.likeDislikeArray[index].expertRepyTotalUnlikes++;
      this.postReaction(postID, "UNLIKE");
    } else if (disliked) {
      this.likeDislikeArray[index].isUnlikedByUser = false;
      this.likeDislikeArray[index].expertRepyTotalUnlikes--;
      this.deleteReaction(postID);
    }
    this.likeDislikeArray[index].disLikeImage = this.disLikeImage(
      this.likeDislikeArray[index].isUnlikedByUser
    );
  }
  postReaction(postID, reaction) {
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl +
          "/api/forum/post/" +
          postID +
          "/reaction/" +
          reaction,
        null,
        headers
      )
      .subscribe((data) => {});
  }
  deleteReaction(postID) {
    let headers = new HttpHeaders();
    this.httpClientService
      .put(
        AppSettings.restApiUrl + "/api/forum/post/" + postID + "/reaction/undo",
        null,
        headers
      )
      .subscribe((data) => {});
  }
  getIndex(postID): number {
    var index = this.likeDislikeArray.findIndex(function (obj) {
      return obj.postID == postID;
    });
    return index;
  }
  getIndexofThread(discussionId): number {
    var index = this.AllForums.findIndex(function (obj) {
      return obj.discussionId == discussionId;
    });
    return index;
  }
  likeImage(image: boolean) {
    if (image) {
      return this.likedImage;
    }
    return this.notLikedImage;
  }
  disLikeImage(image: boolean) {
    if (image) {
      return this.dislikedImage;
    }
    return this.notDislikedImage;
  }
  storeScrollPostion() {
    this.originalScrollPostition = window.scrollY;
  }
  scrollToOriginalPostion() {
    window.scrollTo(0, this.originalScrollPostition);
  }
  addToNotes(index, postId) {
    if (!this.AllForums[index].addedToNotes && this.addToNotesSingle) {
      this.addToNotesSingle = false;
      var forumNoteObject = { forumPostId: postId, objectId: this.activityId };
      let headers = new HttpHeaders();
      this.httpClientService
        .post(
          AppSettings.restApiUrl + "/api/notes/forumPost/create/",
          forumNoteObject,
          headers
        )
        .subscribe((data) => {
          this.AllForums[index].addedToNotes = true;
          this.addToNotesSingle = true;
          this.sessionService.updateActivityNotes(1);
        });
    }
  }
  changeAddedToNoteFlag(forumId) {
    var index = this.getForumIndex(forumId);
    this.AllForums[index].addedToNotes = false;
  }
  getForumIndex(forumId) {
    var index = this.AllForums.findIndex(function (obj) {
      return obj.id == forumId;
    });
    return index;
  }
  postNewQuery() {
    if (!this.postnewQuerySingle) {
      return;
    }
    this.postQueryHeading = this.stripHTMLTags(this.postQueryHeading);
    this.ckeditorNewQueryContent = (this.ckeditorNewQueryContent || "").replace(
      EMOJI_REGEX,
      ""
    );
    var editorTextOnly = this.stripHTMLTags(this.ckeditorNewQueryContent);
    if (editorTextOnly.trim() == "") {
      this.emptyMainPost = true;
      this.characterExceedError = false;
      this.emptyPostSubject = false;
      this.characterExceedSubjectError = false;
      return;
    } else if (this.postQueryHeading.trim() == "") {
      this.emptyPostSubject = true;
      this.emptyMainPost = false;
      this.characterExceedError = false;
      this.characterExceedSubjectError = false;
      return;
    } else if (
      this.postQueryHeading.trim().length > this.ckEditorHeadingLimit
    ) {
      this.characterExceedSubjectError = true;
      this.characterExceedError = false;
      this.emptyPostSubject = false;
      this.emptyMainPost = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.characterExceedError = true;
      this.emptyPostSubject = false;
      this.emptyMainPost = false;
      this.characterExceedSubjectError = false;
      return;
    }
    this.postnewQuerySingle = false;
    var newPostQuery = {
      postSubject: this.postQueryHeading,
      postText: this.ckeditorNewQueryContent,
    };
    this.storeScrollPostion();
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl +
          "/api/" +
          this.activityId +
          "/forum/discussion/" +
          this.isReviewMode +
          "/",
        newPostQuery,
        headers
      )
      .subscribe((data) => {
        this.postQueryHeading = "";
        this.ckeditorNewQueryContent = "";
        this.newQueryPost = false;
        this.emptyMainPost = false;
        this.emptyPostSubject = false;
        this.characterExceedError = false;
        this.postnewQuerySingle = true;
        this.getForumsData(true, data.creationId, false);
        this.scrollToOriginalPostion();
        this.updateResult();
      });
  }
  stripHTMLTags(value): string {
    if (value == null) return value;
    var regex = /(&nbsp;|<([^>]+)>)/gi;
    return value.replace(regex, "");
  }
  postFollowUpQueryOnFollowUpQuery(parentId, followUpCKEditorquery, i, j) {
    if (!this.AllForumsTemplateData[i].forumPostsVO[j].postOneTime) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || "").replace(
      EMOJI_REGEX,
      ""
    );
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[i].forumPostsVO[j].followUpCKEditorEmptyPost =
        true;
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].followUpCKEditorCharacterError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[i].forumPostsVO[
        j
      ].followUpCKEditorCharacterError = true;
      this.AllForumsTemplateData[i].forumPostsVO[j].followUpCKEditorEmptyPost =
        false;
      return;
    }
    this.storeScrollPostion();
    this.AllForumsTemplateData[i].forumPostsVO[j].postOneTime = false;
    this.postFollowUpQuery(parentId, followUpCKEditorquery);
  }
  postFollowUpQueryOnMainQuery(parentId, followUpCKEditorquery, index) {
    if (!this.AllForumsTemplateData[index].postOneTime) {
      return;
    }
    followUpCKEditorquery = (followUpCKEditorquery || "").replace(
      EMOJI_REGEX,
      ""
    );
    var editorTextOnly = this.stripHTMLTags(followUpCKEditorquery);
    if (editorTextOnly.trim() == "") {
      this.AllForumsTemplateData[index].followUpCKEditorEmptyPost = true;
      this.AllForumsTemplateData[index].followUpCKEditorCharacterError = false;
      return;
    } else if (editorTextOnly.trim().length > this.ckEditorWordsLimit) {
      this.AllForumsTemplateData[index].followUpCKEditorCharacterError = true;
      this.AllForumsTemplateData[index].followUpCKEditorEmptyPost = false;
      return;
    }
    this.storeScrollPostion();
    this.AllForumsTemplateData[index].postOneTime = false;
    this.postFollowUpQuery(parentId, followUpCKEditorquery);
  }
  postFollowUpQuery(parentId, followUpCKEditorquery) {
    var newPostQuery = { postSubject: "", postText: followUpCKEditorquery };
    let headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl + "/api/forum/parent/" + parentId + "/",
        newPostQuery,
        headers
      )
      .subscribe((data) => {
        //this.AllForums = [];
        //this.AllForumsTemplateData[index].followUpCKEditor = false;
        this.getForumsData(true, data.creationId, true);
        this.scrollToOriginalPostion();
        this.updateResult();
      });
  }
  ngAfterViewChecked() {
    if (this.ReviewMode && this.scrollOnce) {
      if (document.getElementById(this.corelationID) != null) {
        this.scrollToCurrentDiscussion();
        this.originalScrollPostition =
          document.getElementById(this.getdiscussionID(this.corelationID))
            .offsetTop - 10;
      }
    }
  }
  scrollToFormus() {
    this.displayForumsThreadStart.nativeElement.style.display = "block";
    var forumsLocation = document.getElementById(
      "formus_scroll_point"
    ).offsetTop;
    var body = document.body,
      html = document.documentElement;

    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    var scrollheight = forumsLocation;
    var timerID = setInterval(function () {
      window.scrollBy(0, 20);

      if (
        window.pageYOffset >= scrollheight ||
        window.pageYOffset >= forumsLocation ||
        window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight - 5
      )
        clearInterval(timerID);
    }, 5);
  }
  showActivityForumsd() {
    this.displayForumsThreadStart.nativeElement.style.display = "block";
    this.displayForumsThreadAfter.nativeElement.style.display = "block";
    var forumsLocation = document.getElementById(
      "formus_scroll_point"
    ).offsetTop;
    var body = document.body,
      html = document.documentElement;

    var height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    var scrollheight = height - forumsLocation;
    //console.log(this.activityForumsDisplayHide);
    var timerID = setInterval(function () {
      window.scrollBy(0, 15);

      if (
        window.pageYOffset >= scrollheight ||
        window.pageYOffset >= forumsLocation
      )
        clearInterval(timerID);
    }, 5);
  }
  scrollToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  wheretoplace() {
    let width = window.innerWidth;
    if (width < 500) return "top";
    return "right";
  }
  scrollToCKEditorNewQuery() {
    //var scrollPos = document.getElementById('newQueryPostBtn');
    //setTimeout(function(){window.scrollBy(0, 100);},500);
    /*var timerID = setInterval(function()
    {

        if( scrollableWindow.scrollTop <= 1)
        {
            clearInterval(timerID);
            return;
        }
          scrollableWindow.scrollTop  = scrollableWindow.scrollTop - 15;
    }, 5);*/
  }
  blurFocus() {
    (<HTMLElement>document.activeElement).blur();
  }

  toggleTab(tabName: string) {
    this.tabActive = tabName;
    let isPrimrary = tabName == "important" ? true : false;
    this.getForumsData(isPrimrary, "", false);
  }

    /**
   * update math expression
   */
    updateResult () {
      const mathContainer1 = this.displayForumsThreadAfter.nativeElement.innerHTML
      // Rerender the entire resultDiv
      MathJax.Hub.Queue(["Typeset",MathJax.Hub,mathContainer1]);
    }
}
